export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14879.72f33f65.jpg";